import React, { useEffect, useState } from 'react';
import Loading from './Loading';
import '../styles/_memberTable.scss';

const MemberTable = ({ members, loading, dataError, dashboard }) => {
  const [loadingWait, setLoadingWait] = useState(false);
  useEffect(() => {
    // show loading animation for at least 2 seconds
    setTimeout(function () {
      setLoadingWait(true)
    }, 2000);
  }, [])

  if (dataError !== '') {
    return (
      <p className="table-message">{ dataError }</p>
    )
  }

  if (!loading && members.length === 0) {
    return (
      <p className="table-message">{dashboard ? 'You have no memberships :(' : 'There are no results with your filter criteria. Searches are case-sensitive.'}</p>
    )
  }

  return (
    <div className="member-table">
      { (loading || !loadingWait) &&
        <Loading></Loading>
      }
      <table>      
        <thead>
          <tr>
            <th>Member #</th>
            <th>Status</th>
            <th>Start Date</th>
            <th>Expiration Date</th>
            <th>Member Name</th>
            <th>Year</th>
            <th>Make</th>
            <th>Model</th>
            <th>Plate</th>
            <th>Color</th>
          </tr>
        </thead>
        <tbody>
          {members && members.map((result, index) => {
            return (
              <tr key={'membership--' + index} className={`${index % 2 === 1 ? 'highlight' : ''}`}>
                <td>{result.memberNumber}</td>
                <td className={result.status === 'Expired' || result.status === 'Unassigned' ? 'expired' : ''}>{result.status}</td>
                <td>{result.startDate}</td>
                <td>{result.expirationDate}</td>
                {dashboard &&
                  <td>{result.memberName}</td>
                }
                {!dashboard &&
                  <td><a href={`mailto:${result.email}`} target="_blank">{result.memberName}</a></td>
                }
                <td>{result.year}</td>
                <td>{result.make}</td>
                <td>{result.model}</td>
                <td>{result.licensePlate}</td>
                <td>{result.color}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default MemberTable;